<script>
import Layout from "@layouts/auth";
import api from "@services/api";

export default {
  page: {
    title: "Cadastrar nova senha",
    meta: [
      {
        name: "description",
        content: `Register new password`
      }
    ]
  },
  components: {
    Layout
  },
  data() {
    return {
      item: {
        email: "",
        hash: ""
      }
    };
  },
  created() {
    this.$store.dispatch("alert/clear");
    if (this.$route.query.email) {
      this.item.email = this.$route.query.email;
    }
    if (this.$route.query.hash) {
      this.item.hash = this.$route.query.hash;
    }
    if (this.item.email === "" || this.item.hash === "") {
      this.back();
    }
  },
  computed: {
    alert() {
      return this.$store.state.alert;
    }
  },
  methods: {
    save() {
      if (this.item.senhaNova !== this.item.senhaNovaConfirmacao) {
        this.$store.dispatch(
          "alert/error",
          'Os campos "Nova senha" e "Confirme a nova senha" devem ser iguais.',
          { root: true }
        );
      } else {
        api.post(`api/Login/CadastrarSenha`, this.item).then(response => {
          if (response.data["status"].toLowerCase() == "success") {
            this.logout();
          } else {
            throw response;
          }
        });
      }
    },
    logout() {
      this.$router.push(
        this.$route.query.redirectFrom || {
          path: `/Logout`
        }
      );
    },
    back() {
      this.$router.push(
        this.$route.query.redirectFrom || {
          path: `/`
        }
      );
    },
    closeAlert() {
      this.$store.dispatch("alert/clear");
    }
  }
};
</script>

<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-12 col-lg-6 col-xl-5">
        <div class="card">
          <div class="card-body p-4">
            <div class="text-center w-75 m-auto">
              <a href="/">
                <span
                  ><img
                    src="@assets/images/logo-dark.png"
                    class="logo  m-auto"
                    alt=""
                    height="50"
                /></span>
              </a>
              <p class="text-muted mb-3 mt-3">
                Cadastre uma nova <strong>senha</strong> para o e-mail
                <strong>{{ item.email }}</strong>
              </p>
            </div>

            <b-form @submit.prevent="save">
              <b-form-group id="email-group" label="E-mail" label-for="email">
                <b-form-input
                  id="email"
                  v-model="item.email"
                  :disabled="true"
                  required
                ></b-form-input>
              </b-form-group>

              <b-form-group
                id="input-group-2"
                label="Nova senha"
                label-for="senhaNova"
              >
                <b-form-input
                  id="senhaNova"
                  v-model="item.senhaNova"
                  type="password"
                  required
                ></b-form-input>
              </b-form-group>

              <b-form-group
                id="input-group-2"
                label="Confirme a nova senha"
                label-for="senhaNovaConfirmacao"
              >
                <b-form-input
                  id="senhaNovaConfirmacao"
                  v-model="item.senhaNovaConfirmacao"
                  type="password"
                  required
                ></b-form-input>
              </b-form-group>

              <b-alert
                variant="danger"
                dismissible
                :show="alert.show"
                @dismissed="closeAlert"
              >
                {{ alert.message }}
              </b-alert>

              <b-form-group id="button-group" class="mt-4">
                <b-button type="submit" variant="primary" class="btn-block"
                  >Salvar</b-button
                >
              </b-form-group>
            </b-form>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>

<style lang="scss" module></style>
